import '../../../App.scss';
import React from 'react';
import { Alert, Modal, Spinner } from 'react-bootstrap';

export default function BlockScreen(props) {
    /*
    Usage:
        import BlockScreen from '../../components/alerts/blockScreen/BlockScreen';
    
        (...)
        const [stateOfBlockScreen, setStateOfBlockScreen] = useState({
            show: false,
            variant: 'info',
            className: '',
        });
    
        (...)
            <BlockScreen
                show={stateOfBlockScreen.show}
                variant={stateOfBlockScreen.variant}
                className={stateOfBlockScreen.className}
            />
    */

    if (!props.show) {
        return <></>
    }

    return (
        <Modal show={props.show} animation={false}>
            <Alert variant={props.variant || "info"} className={`mb-0 ${props.className}`}>
                <div className='spinner-centered'>
                    <Spinner animation='border' variant={props.variant || 'info'} />
                </div>
            </Alert>
        </Modal>
    );
}
